// extracted by mini-css-extract-plugin
module.exports = {"section-title__title-container":"SectionTitle_section-title__title-container__1HCTz","section-title__title":"SectionTitle_section-title__title__2uHJT"};